"use strict";

module.exports = class {

    #validationMessages = {
        zip_code: 'Please enter your 5-digit zip code.',
        phone_number: 'Please enter your ten-digit phone number with area code (no dashes or other special characters).'
    }

    get validationMessages() {
        return this.#validationMessages;
    }

    getValidatedZipCode($input) {
        if (!$input) {
            return null;
        }
        return $input.val().replace(/\D/g, '').slice(0, 5);
    }

    getValidatedPhoneNumber($input) {
        if (!$input) {
            return null;
        }
        return $input.val().replace(/\D/g, '').slice(0, 10);
    }

    getValidationMessage(field) {
        return (typeof this.validationMessages[field] !== 'undefined') ? this.validationMessages[field] : '';
    }

}